export default __webpack_public_path__ + "static/media/mangoes.44eab2fd.jpg";